export const formatter = {
	price(value: number = 0) {
		return new Intl.NumberFormat("he-IL", {
			style: "currency",
			currency: "ILS",
		}).format(value);
	},
	date(value?: number | undefined) {
		if (!value) return "";
		return new Date(value).toLocaleDateString("he-IL", {});
	},
	// Clean display for item quantities/weights. Float arithmetic can leave a long
	// tail (e.g. 1.9249999999999998 instead of 1.925); round to 3 decimals.
	// For weight/measured products show the FULL weighed amount with a fixed 3
	// decimals (2.5 → "2.500", 3 → "3.000") so a trailing zero is never dropped —
	// it must read exactly like the scale. Unit products keep the clean form that
	// drops trailing zeros ("1.925", "1.59", "5").
	qty(value: number = 0, options?: { weight?: boolean }) {
		return new Intl.NumberFormat("he-IL", {
			minimumFractionDigits: options?.weight ? 3 : 0,
			maximumFractionDigits: 3,
		}).format(value);
	},
};
